"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var error_message_1 = __importDefault(require("../components/error-message"));
var styling_1 = require("./styling");
var Names = function (_a) {
    var NavBar = _a.NavBar, initialStepFormData = _a.initialStepFormData, setStepFormData = _a.setStepFormData;
    var _b = (0, react_hook_form_1.useForm)({ defaultValues: initialStepFormData, mode: 'onChange' }), register = _b.register, handleSubmit = _b.handleSubmit, errors = _b.errors, formState = _b.formState, control = _b.control;
    var email = (0, react_hook_form_1.useWatch)({ control: control, name: 'email' });
    var onSubmit = function (data) { return setStepFormData(data); };
    var beforeGoNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var canGoNext, onError;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    canGoNext = true;
                    onError = function () {
                        canGoNext = false;
                    };
                    return [4 /*yield*/, handleSubmit(onSubmit, onError)()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, canGoNext];
            }
        });
    }); };
    var titleOptions = [
        'Master of the Realm',
        'Sir Screams A Lot',
        'Madam Mess-Maker',
        'King of the Crib',
        'Queen of the Crib',
        'Chief Exhausting Officer',
        'Professor of Peeology',
        'Prince Poopypants',
        'Princess Poopypants',
        'Doctor Doody',
        'Officer Tooty-Booty',
        'Archduke Anklebiter',
        'Archduchess Anklebiter',
        'Director of Sleep Deprivation',
        'Governor of Googoo Gaga',
        'Mayor of Bootyville',
        'Nurse Neversleeps',
        'General Tinkle-Pooper',
        'Manager of Mombies',
        'Captain Kissyface',
        'Eat, Sleep, Poop Advisor',
        'Lady Laundry-Maker',
        'Lord Laundry-Maker',
        'Blowout Barista',
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'h-8' }),
        react_1.default.createElement("div", null,
            react_1.default.createElement("form", { className: styling_1.formClassName },
                react_1.default.createElement("div", { className: 'padding-horizontal-6 width-100 text', style: { maxWidth: styling_1.maxWidth } }, "Let\u2019s get ready to bundle! Our quick quiz will help us show you the goods that are good for you."),
                react_1.default.createElement("label", { htmlFor: 'parentFirstName', className: styling_1.fieldContainerClassName, style: styling_1.fieldContainerStyle },
                    react_1.default.createElement("div", { className: styling_1.fieldHeadingClassName }, "What\u2019s Your First Name?"),
                    react_1.default.createElement("input", { className: styling_1.inputClassName, style: styling_1.inputStyle, id: 'parentFirstName', name: 'parentFirstName', type: 'text', autoComplete: 'given-name', spellCheck: false, autoCapitalize: 'off', placeholder: 'Name', ref: register() }),
                    react_1.default.createElement(error_message_1.default, { error: errors.parentFirstName })),
                react_1.default.createElement("label", { htmlFor: 'email', className: styling_1.fieldContainerClassName, style: styling_1.fieldContainerStyle },
                    react_1.default.createElement("div", { className: styling_1.fieldHeadingClassName }, "What\u2019s Your Email?"),
                    react_1.default.createElement("input", { className: styling_1.inputClassName, style: styling_1.inputStyle, id: 'email', name: 'email', type: 'text', autoComplete: 'email', spellCheck: false, autoCapitalize: 'off', placeholder: 'Email', ref: register({ pattern: { value: /\S+@\S+\.\S+/, message: 'Please enter a valid email address' } }) }),
                    email && !errors.email && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: 'flex-container justify-center' },
                            react_1.default.createElement("div", { className: 'text-xs text-gray width-100' }, "By pressing \u201CNext\u201D you are signing up to receive Hello Bello emails and can unsubscribe at any time.")))),
                    react_1.default.createElement(error_message_1.default, { error: errors.email })),
                react_1.default.createElement("label", { htmlFor: 'babyFirstName', className: styling_1.fieldContainerClassName, style: styling_1.fieldContainerStyle },
                    react_1.default.createElement("div", { className: styling_1.fieldHeadingClassName }, "What\u2019s Your Baby\u2019s Name?"),
                    react_1.default.createElement("input", { className: styling_1.inputClassName, style: styling_1.inputStyle, id: 'babyFirstName', name: 'babyFirstName', type: 'text', autoComplete: 'off', spellCheck: false, autoCapitalize: 'off', placeholder: 'Baby\u2019s first name', ref: register() }),
                    react_1.default.createElement(error_message_1.default, { error: errors.babyFirstName })),
                react_1.default.createElement("label", { htmlFor: 'babyTitle', className: styling_1.fieldContainerClassName, style: styling_1.fieldContainerStyle },
                    react_1.default.createElement("div", { className: styling_1.fieldHeadingClassName }, "Baby\u2019s Title?"),
                    react_1.default.createElement("select", { className: styling_1.inputClassName, style: styling_1.inputStyle, id: 'babyTitle', name: 'babyTitle', autoComplete: 'off', spellCheck: false, autoCapitalize: 'off', ref: register() },
                        react_1.default.createElement("option", { value: '' }, "Select a title"),
                        titleOptions.map(function (option) { return (react_1.default.createElement("option", { key: option, value: option }, option)); })),
                    react_1.default.createElement(error_message_1.default, { error: errors.babyTitle })))),
        react_1.default.createElement(NavBar, { backButtonHidden: true, backButtonEnabled: false, nextButtonEnabled: formState.isValid, beforeGoNext: beforeGoNext })));
};
exports.default = Names;
